import React from 'react';
import { ClosedCaptions as ReactClosedCaptions, ClosedCaptionsProps, ClosedCaption, } from '@doxyme/ui';
import { useCaptions } from '../../../captions';
export { ClosedCaptionsProps, ClosedCaption };
export const ClosedCaptions = ({ translatedText, onClose, }) => {
    const { captions: captionsFromStore, bottomOffset } = useCaptions();
    const closedCaptions = captionsFromStore.map((caption) => ({
        name: caption.showName === true ? caption.name : undefined,
        caption: caption.caption,
    }));
    return (<ReactClosedCaptions captions={closedCaptions} bottomOffset={bottomOffset} onClose={onClose} translatedText={translatedText}/>);
};
ClosedCaptions.displayName = 'ClosedCaptions';
